export const CURRENT_CONFIG = {
  // license
  appId: '167705', // You need to go to the development website to apply.
  appKey: 'ca6a1cc6d4766468c12d40de14885b2', // You need to go to the development website to apply.
  appLicense: 'GRyN8D0OomeIlgFz8REkmjfqCHJYVH9tL3JkyGI/CL2JKDceiAS5dLINP9FB49xu4Lybc+1zKxuOPgxl7Fx9mEWQH90xRq741JFS+jdWdXgsz1w4Dxs5qPxRnyhQDGyMBvIIpmfaY9nyT1yfNnn7+EnzmQvmeVZzqVRHn9eEN0Y=',

  // http  *** UPDATED ***
  baseURL: 'https://skylink-connect.au/', // MUST end with /
  websocketURL: 'wss://skylink-connect.au/api/v1/ws',

  // livestreaming
  rtmpURL: 'Please enter the rtmp access address.',
  gbServerIp: 'Please enter the server ip.',
  gbServerPort: 'Please enter the server port.',
  gbServerId: 'Please enter the server id.',
  gbAgentId: 'Please enter the agent id',
  gbPassword: 'Please enter the agent password',
  gbAgentPort: 'Please enter the local port.',
  gbAgentChannel: 'Please enter the channel.',

  // RTSP
  rtspUserName: 'Please enter the username.',
  rtspPassword: 'Please enter the password.',
  rtspPort: '8554',

  // Agora
  agoraAPPID: 'Please enter the agora app id.',
  agoraToken: 'Please enter the agora temporary token.',
  agoraChannel: 'Please enter the agora channel.',

  // map
  amapKey: 'Please enter the amap key.',
}
